import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import toast from '../../shared/Toast';
// import '../service.css';
import Select from 'react-select';
import InlinePickerSelect from '../../shared/InlinePickerSelect';
import { newServices } from "../../../_services/newservices.service";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CancelSaveBtn from "./CancelSaveBtn";
import useWindowSize from "../useWindowSize";
import { newServicesAction } from "../../../_actions";
import { useParams } from "react-router-dom";
import { formService } from "../../../_services/form.service";
import CatalogueTopNav from "../CatalogueTopNav";
import ColourPicker from '../../shared/ColourPicker';
import ServiceCodes from '../../discounts/pickers/ServiceCodes';
import { normaliseImage } from '../../shared/normaliseImage';
import '../../forms/Forms.css';
import '../ServiceEditorPanel.css';
import { markFirstTask } from '../../onboarding/firstTaskRegistry';

function EditService(props) {
    // const [serviceName, setServiceName] = useState('');
    // const [category, setCategory] = useState(null);
    // const [serviceTime,setServiceTime] =useState('')
    // const [description, setDescription ] = useState("")
    const dispatch = useDispatch();
    const {id} = useParams();
    const[showTooltip , setShowTooltip] = useState(false);
    const [serviceData, setServiceData] = useState({
        serviceName: '',
        description: '',
        category: null,
        defaultDiaryColour: '#c8eeee', // Default diary color for the service
        serviceImages: [], // Top-level service images (array)
        serviceEditBy: {
            name: "",
            userImage: {
              circleImage: null,
              rectangleImage: null
            }
        },
        isFeaturedForSalon: false, // Salon-level featured status
        staffSettings:[
          {
            hairdresserId: "",
            servicePrice: 0,
            serviceTime: 0,
            isDeactivated: false,
            depositPrice: 0,
            onlineBooking: false,
            processingTime: 0,
            diaryColour: '#c8eeee', // Default light cyan color
            isColourOverridden: false, // Track if color is manually overridden
            staffServiceImages: [], // Staff-level service images (array)
            isFeaturedForStaff: false // Staff-level featured status
          }
        ]
        
    });
    const [uploadingServiceImage, setUploadingServiceImage] = useState(false);
    const [uploadingStaffImage, setUploadingStaffImage] = useState(null); // Track which staff image is uploading
    const [errors, setErrors] = useState({});
    // Available automatic forms (for linking to staff)
    const [availableAutoForms, setAvailableAutoForms] = useState([]);
    // Auto-attached forms (from FormSettings "every_service" or "specific_services" targeting this service)
    const [autoAttachedForms, setAutoAttachedForms] = useState([]);
    // All services for booking rules pickers
    const [allServices, setAllServices] = useState([]);
    const [finishingSearch, setFinishingSearch] = useState('');
    const [consultationSearch, setConsultationSearch] = useState('');
    // Track which staff row has the form selector open
    const [formSelectorOpenIndex, setFormSelectorOpenIndex] = useState(null);
    // Track which staff member's detail panel is open (null = closed)
    const [selectedStaffIndex, setSelectedStaffIndex] = useState(null);
    // Tab navigation state
    const [activeTab, setActiveTab] = useState('detail');
    const history = useHistory();
    const { width } = useWindowSize();
    const listCategory = useSelector(state => state.newServices.listCategory);
    const listHairdresser = useSelector(state => state?.newServices?.listHairdresser);
    const userInfo = useSelector(state => state.user);
    // Check if user is a salon manager based on the actual user data structure
    const isSalonManager = userInfo?.userInfo?.hairdresser?.isSalonOwner === 1;
    console.log("EditService - User Info:", userInfo, "Is Salon Manager:", isSalonManager);
    const [serviceResponse, setServiceResponse] = useState(null);
    const showTooltipFn=()=>{setShowTooltip(true)}
    const hideTooltipFn=()=>{setShowTooltip(false)}
    console.log("listHairdresserlistHairdresser1",listHairdresser)
    const categoryOptions = listCategory?.map(category => ({
      value: category?._id, // Use '_id' for the value
      label: category?.categoryName // Use 'categoryName' for the label
    }));

    const customStyles = {
      control: (provided) => ({
        ...provided,
        borderColor: '#e5e5e5',
        borderRadius: '10px',
        minHeight: '44px',
        boxShadow: 'none',
        fontSize: '14px',
        '&:hover': {
          borderColor: '#c0c0c0',
        },
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#1a1a1a' : 'white',
        color: state.isSelected ? 'white' : '#1a1a1a',
        fontSize: '14px',
        padding: '10px 14px',
        '&:hover': {
          backgroundColor: state.isSelected ? '#1a1a1a' : '#f5f5f5',
        },
      }),
      placeholder: (provided) => ({
        ...provided,
        color: '#9ca3af',
      }),
    };

    const categoryList = () => {
        const payload = {}
        dispatch(newServicesAction.listCategoryData(payload))
            .then((res) => {
                console.log("Category list successfully:", res);

            })
            .catch((error) => {
                console.error("Error with category list:", error);
            });
    }

    const handleStaffSettingChange = (index, field, value) => {
      console.log(`handleStaffSettingChange: index=${index}, field=${field}, value=${value}`);
      
      if (field === "isDeactivated"  && value == true) {
        const error = validateFields(field, value );
        setErrors(prev => ({
          ...prev,
          [`${field}_${index}`]: error
        }));
      }
      else if (field === "serviceTime"  && value !== 0) {
        const error = validateFields(field, value );
        setErrors(prev => ({
          ...prev,
          [`${field}_${index}`]: error
        }));
      } else if(field === "processingTime"  && value !== 0) {
        const error = validateFields(field, value);
        setErrors(prev => ({
          ...prev,
          [`${field}_${index}`]: error
        }));
      } else {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[`${field}_${index}`];
          return newErrors;
        });
      }

      // Use functional update to ensure we're working with the latest state
      setServiceData(prev => {
        // Create a completely new array with new staff objects to avoid reference issues
        const newStaffSettings = prev.staffSettings.map((staff, i) => {
          // Only update the staff at the specified index
          if (i === index) {
            const updatedStaff = { ...staff };
            
            // If changing diary color, mark it as overridden
            if (field === "diaryColour") {
              updatedStaff.diaryColour = value;
              updatedStaff.isColourOverridden = true;
              console.log(`Setting row ${index} color to ${value} and isColourOverridden to true`);
            } else {
              updatedStaff[field] = value;
            }
            
            return updatedStaff;
          }
          
          // Return a new copy of unchanged staff objects
          return { ...staff };
        });
        
        // Return a completely new state object
        return {
          ...prev,
          staffSettings: newStaffSettings
        };
      });
    };
    
    // Handle default diary color change
    const handleDefaultDiaryColourChange = (value) => {
      console.log("Default color changed to:", value);
      
      // Use functional update to ensure we're working with the latest state
      setServiceData(prev => {
        // Create a new staff settings array with new objects to avoid reference issues
        const newStaffSettings = prev.staffSettings.map(staff => {
          // Create a new staff object
          const newStaff = { ...staff };
          
          // Only update if not manually overridden
          if (!newStaff.isColourOverridden) {
            newStaff.diaryColour = value;
            console.log(`Updated staff ${newStaff.hairdresserId} color to ${value}`);
          } else {
            console.log(`Skipped staff ${newStaff.hairdresserId} - color is overridden`);
          }
          
          return newStaff;
        });
        
        console.log("Updated staff settings:", newStaffSettings);
        
        // Return the updated state with both the default color and updated staff settings
        return {
          ...prev,
          defaultDiaryColour: value,
          staffSettings: newStaffSettings
        };
      });
    };
    
    // Reset diary color to last saved color
    const handleResetToLastSaved = () => {
      console.log("Reset to Last Saved button clicked");
      
      // Get the default diary color from the service response
      // If the service doesn't have a diaryColour property, use the first hairdresser's color
      // or fall back to '#c8eeee' if no colors are available
      const lastSavedColor = serviceResponse?.diaryColour ||
                          (serviceResponse?.hairdresserService?.[0]?.diaryColour) ||
                          '#c8eeee';
      
      console.log("Resetting to last saved color:", lastSavedColor);
      
      // Create brand new staff settings objects with last saved colors
      const resetStaffSettings = serviceData.staffSettings.map(staff => {
        // Find the corresponding hairdresser service in the response
        const hairdresserService = serviceResponse?.hairdresserService?.find(
          hs => hs.hairdresserId === staff.hairdresserId
        );
        
        // Use the hairdresser's saved color or the default last saved color
        const staffColor = hairdresserService?.diaryColour || lastSavedColor;
        
        return {
          ...staff,
          diaryColour: staffColor,
          isColourOverridden: false
        };
      });
      
      console.log("Reset staff settings:", resetStaffSettings);
      
      // Directly set the state with the new objects
      setServiceData({
        ...serviceData,
        defaultDiaryColour: lastSavedColor,
        staffSettings: resetStaffSettings
      });
    };
    
    // Reset diary color to system default (#c8eeee)
    const handleResetToSystem = () => {
      console.log("Reset to System button clicked");
      const systemDefaultColor = '#c8eeee';
      
      console.log("Before reset - defaultDiaryColour:", serviceData.defaultDiaryColour);
      
      // Create a completely new state object to avoid reference issues
      const newServiceData = {
        ...serviceData,
        defaultDiaryColour: systemDefaultColor,
        staffSettings: serviceData.staffSettings.map(staff => ({
          ...staff,
          diaryColour: systemDefaultColor,
          isColourOverridden: false
        }))
      };
      
      console.log("After reset - new defaultDiaryColour:", newServiceData.defaultDiaryColour);
      
      // Set the state with the completely new object
      setServiceData(newServiceData);
    };
    
    // Handle service image upload (top-level) - supports multiple images
    const handleServiceImageUpload = async (e) => {
      const picked = e.target.files[0];
      const inputElement = e.target; // Store reference before async operations
      if (!picked) return;

      // iOS can leave the type blank for HEIC picks, so only refuse a
      // file that says it is something other than an image.
      if (picked.type && !picked.type.startsWith('image/')) {
        toast.error('Please select an image file');
        return;
      }

      // HEIC → JPEG and shrink to ~2048px (shared/normaliseImage). Modern
      // iPhone photos are often over 5MB and were refused outright before.
      const file = await normaliseImage(picked);
      if (file.size > 10 * 1024 * 1024) {
        toast.error('That image is too large. Please try another.');
        return;
      }
      
      setUploadingServiceImage(true);
      
      const formData = new FormData();
      formData.append('serviceImage', file);
      formData.append('commonServiceId', id);
      
      try {
        const res = await dispatch(newServicesAction.uploadServiceImageData(formData));
        console.log("Service image upload response:", res);
        
        if (res?.uploadServiceImage?.statusCode === 1) {
          const imageUrl = res?.uploadServiceImage?.responseData?.result?.imageUrl;
          setServiceData(prev => ({
            ...prev,
            serviceImages: [...(prev.serviceImages || []), imageUrl]
          }));
          toast.success('Service image uploaded successfully');
        } else {
          toast.error(res?.uploadServiceImage?.error?.responseMessage || 'Failed to upload image');
        }
      } catch (error) {
        console.error("Error uploading service image:", error);
        toast.error('Failed to upload image');
      } finally {
        setUploadingServiceImage(false);
        // Reset the file input using stored reference
        if (inputElement) {
          inputElement.value = '';
        }
      }
    };
    
    // Handle staff service image upload - supports multiple images
    const handleStaffServiceImageUpload = async (e, staffIndex, hairdresserId) => {
      const picked = e.target.files[0];
      const inputElement = e.target; // Store reference before async operations
      if (!picked) return;

      // iOS can leave the type blank for HEIC picks, so only refuse a
      // file that says it is something other than an image.
      if (picked.type && !picked.type.startsWith('image/')) {
        toast.error('Please select an image file');
        return;
      }

      // HEIC → JPEG and shrink to ~2048px (shared/normaliseImage). Modern
      // iPhone photos are often over 5MB and were refused outright before.
      const file = await normaliseImage(picked);
      if (file.size > 10 * 1024 * 1024) {
        toast.error('That image is too large. Please try another.');
        return;
      }
      
      setUploadingStaffImage(staffIndex);
      
      const formData = new FormData();
      formData.append('staffServiceImage', file);
      formData.append('commonServiceId', id);
      formData.append('hairdresserId', hairdresserId);
      
      try {
        const res = await dispatch(newServicesAction.uploadStaffServiceImageData(formData));
        console.log("Staff service image upload response:", res);
        
        if (res?.uploadStaffServiceImage?.statusCode === 1) {
          const imageUrl = res?.uploadStaffServiceImage?.responseData?.result?.imageUrl;
          setServiceData(prev => ({
            ...prev,
            staffSettings: prev.staffSettings.map((staff, i) =>
              i === staffIndex ? { ...staff, staffServiceImages: [...(staff.staffServiceImages || []), imageUrl] } : staff
            )
          }));
          toast.success('Staff service image uploaded successfully');
        } else {
          toast.error(res?.uploadStaffServiceImage?.error?.responseMessage || 'Failed to upload image');
        }
      } catch (error) {
        console.error("Error uploading staff service image:", error);
        toast.error('Failed to upload image');
      } finally {
        setUploadingStaffImage(null);
        // Reset the file input using stored reference
        if (inputElement) {
          inputElement.value = '';
        }
      }
    };
    
    // Handle delete service image - removes specific image from array
    const handleDeleteServiceImage = async (imageUrl) => {
      try {
        const res = await dispatch(newServicesAction.deleteServiceImageData({
          commonServiceId: id,
          imageType: 'service',
          imageUrl: imageUrl
        }));
        
        if (res?.deleteServiceImage?.statusCode === 1) {
          setServiceData(prev => ({
            ...prev,
            serviceImages: (prev.serviceImages || []).filter(img => img !== imageUrl)
          }));
          toast.success('Service image deleted successfully');
        } else {
          toast.error(res?.deleteServiceImage?.error?.responseMessage || 'Failed to delete image');
        }
      } catch (error) {
        console.error("Error deleting service image:", error);
        toast.error('Failed to delete image');
      }
    };
    
    // Handle delete staff service image - removes specific image from array
    const handleDeleteStaffServiceImage = async (staffIndex, hairdresserId, imageUrl) => {
      try {
        const res = await dispatch(newServicesAction.deleteServiceImageData({
          commonServiceId: id,
          imageType: 'staff',
          hairdresserId: hairdresserId,
          imageUrl: imageUrl
        }));
        
        if (res?.deleteServiceImage?.statusCode === 1) {
          setServiceData(prev => ({
            ...prev,
            staffSettings: prev.staffSettings.map((staff, i) =>
              i === staffIndex ? { ...staff, staffServiceImages: (staff.staffServiceImages || []).filter(img => img !== imageUrl) } : staff
            )
          }));
          toast.success('Staff service image deleted successfully');
        } else {
          toast.error(res?.deleteServiceImage?.error?.responseMessage || 'Failed to delete image');
        }
      } catch (error) {
        console.error("Error deleting staff service image:", error);
        toast.error('Failed to delete image');
      }
    };

    // Toggle featured status for salon (all staff members)
    const handleToggleFeaturedForSalon = async () => {
      const newFeaturedStatus = !serviceData.isFeaturedForSalon;
      
      try {
        const res = await dispatch(newServicesAction.toggleFeaturedService({
          commonServiceId: id,
          featuredType: 'salon',
          isFeatured: newFeaturedStatus
        }));
        
        if (res?.toggleFeatured?.statusCode === 1) {
          setServiceData(prev => ({
            ...prev,
            isFeaturedForSalon: newFeaturedStatus
          }));
          toast.success(newFeaturedStatus ? 'Service featured for salon' : 'Service unfeatured for salon');
        } else {
          toast.error(res?.toggleFeatured?.error?.responseMessage || 'Failed to update featured status');
        }
      } catch (error) {
        console.error("Error toggling featured status:", error);
        toast.error('Failed to update featured status');
      }
    };
    
    // Toggle featured status for individual staff member
    const handleToggleFeaturedForStaff = async (staffIndex, hairdresserId) => {
      const staff = serviceData.staffSettings[staffIndex];
      const newFeaturedStatus = !staff.isFeaturedForStaff;
      
      try {
        const res = await dispatch(newServicesAction.toggleFeaturedService({
          commonServiceId: id,
          hairdresserId: hairdresserId,
          featuredType: 'staff',
          isFeatured: newFeaturedStatus
        }));
        
        if (res?.toggleFeatured?.statusCode === 1) {
          setServiceData(prev => ({
            ...prev,
            staffSettings: prev.staffSettings.map((s, i) =>
              i === staffIndex ? { ...s, isFeaturedForStaff: newFeaturedStatus } : s
            )
          }));
          toast.success(newFeaturedStatus ? 'Service featured for staff' : 'Service unfeatured for staff');
        } else {
          toast.error(res?.toggleFeatured?.error?.responseMessage || 'Failed to update featured status');
        }
      } catch (error) {
        console.error("Error toggling featured status:", error);
        toast.error('Failed to update featured status');
      }
    };

    const validateFields = (name, value ) => {
      let error = '';
      switch (name) {
          case 'serviceName':
              if (!value) {
                  error = "Service Name is required.";
              }
              break;
          case 'category':
              if (!value) {
                  error = "Category is required.";
              }
              break;
          case 'serviceTime':
           if (value!=0 && value%5!=0) {
                  error = "Must be multiple of 5.";
              }
              break;
          case 'processingTime':
              if (value!=0 && value%5!=0) {
                  error = "Must be multiple of 5.";
              }
              break;
              
          default:
              break;
      }
      return error;
    };

    const handleChange = (e) => {
      const { name, value } = e.target;
      
      if (name === "serviceName" || name === "description") {
        const error = validateFields(name, value);
        setErrors(prev => ({
          ...prev,
          [name]: error
        }));
      } else {
        // Clear the error if the field is valid or empty
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    
      setServiceData(prev => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleCategoryChange = (selected) => {
        setServiceData(prev => ({
            ...prev,
            category: selected,
        }));
        setErrors(prev => ({
            ...prev,
            category: validateFields('category', selected)
        }));
    };

    const handleSave = () => {
      setErrors({});
  
      const newErrors = {
        serviceName: validateFields('serviceName', serviceData.serviceName),
        category: validateFields('category', serviceData.category)
      };
    
      if (serviceData.staffSettings && Array.isArray(serviceData.staffSettings)) {
        for (let index = 0; index < serviceData.staffSettings.length; index++) {
          const staff = serviceData.staffSettings[index];

          if (staff.isDeactivated == true && ( staff.serviceTime == '' || staff.serviceTime == 0)) {
            newErrors[`serviceTime_${index}`] = "Service time can't be set to 0 when service is enabled";
          } else if (staff.serviceTime) {
            const serviceTimeError = validateFields('serviceTime', parseInt(staff.serviceTime));
            if (serviceTimeError) {
              newErrors[`serviceTime_${index}`] = serviceTimeError;
            }
          }
         
          if (staff.processingTime) {
            const processingTimeError = validateFields('processingTime', parseInt(staff.processingTime));
            if (processingTimeError) {
              newErrors[`processingTime_${index}`] = processingTimeError;
            }
          }

          if (parseFloat(staff.depositPrice) > parseFloat(staff.servicePrice)) {
            newErrors[`depositPrice_${index}`] = "Deposit price cannot be greater than service price.";
          }

        }
      }
    
      const filteredErrors = Object.fromEntries(
        Object.entries(newErrors).filter(([_, v]) => v !== '')
      );
      
      setErrors(filteredErrors);
    
      if (Object.keys(filteredErrors).length > 0) {
        return;
      }
      // Prepare the payload with proper color handling
      // Make sure we're using the user-selected color, but provide a fallback if it's undefined
      const defaultColor = serviceData.defaultDiaryColour || '#c8eeee';
      console.log("Default color for saving:", defaultColor);
      
      const payload = {
        commonServiceId:id,
        serviceName:serviceData.serviceName,
        categoryID: serviceData?.category ? serviceData?.category.value: "",
        serviceDescription: serviceData.description,
        diaryColour: defaultColor, // Use diaryColour field for the default color
        hairdresserService: serviceData.staffSettings?.map(staff => {
          // Determine the color to use for this staff member
          // If not manually overridden, use the default color
          // Make sure staff.diaryColour has a fallback if it's undefined
          const staffColor = staff.isColourOverridden ? (staff.diaryColour || defaultColor) : defaultColor;
          console.log(`Staff ${staff.hairdresserId}: isOverridden=${staff.isColourOverridden}, color=${staffColor}`);
          
          return {
            hairdresserId: staff.hairdresserId,
            servicePrice: parseFloat(staff.servicePrice) || 0,
            serviceTime: parseFloat(staff.serviceTime) || 0,
            isDeactivated: !staff.isDeactivated,
            depositPrice: parseFloat(staff.depositPrice) || 0,
            onlineBooking: staff.onlineBooking,
            processingTime: parseFloat(staff.processingTime) || 0,
            setupTime: parseFloat(staff.setupTime) || 0,
            cleanupTime: parseFloat(staff.cleanupTime) || 0,
            requiresFinishing: staff.requiresFinishing || false,
            finishingServiceIds: staff.finishingServiceIds || [],
            finishingSameStylist: staff.finishingSameStylist !== false,
            requiresConsultation: staff.requiresConsultation || false,
            consultationServiceId: staff.consultationServiceId || null,
            consultationSameStylist: staff.consultationSameStylist !== false,
            finishingMessage: staff.finishingMessage || '',
            consultationMessage: staff.consultationMessage || '',
            diaryColour: staffColor,
            isColourOverridden: staff.isColourOverridden || false,
            linkedForms: (staff.linkedForms || []).map(f => ({
              formId: f.formId,
              formName: f.formName,
              isRequired: f.isRequired !== false
            }))
          };
        }),
      };
      console.log("Saving add service data1212:", payload);
      dispatch(newServicesAction.editServicesData(payload))
      .then((res) => {
         console.log("Category edited successfully:", res);
          if(res?.editServices?.statusCode===1) {
            toast.success(res?.editServices?.responseData?.message);
            markFirstTask('menu'); // onboarding: made the menu their own
          }
          else{
            toast.error(res?.editServices?.error?.responseMessage);
          }
        history.push("/new-services");
      })
      .catch((error) => {
        console.error("Error edit service:", error);
      });
    };


    const viewService = async (serviceId) => {
      const payload = { commonServiceId: serviceId };
      dispatch(newServicesAction.viewServiceData(payload))
          .then((res) => {
              setServiceResponse(res?.viewService);
          })
          .catch((error) => {
              console.error("Error fetching service data:", error);
          });
  };


    useEffect(()=>{
        categoryList();
        // Fetch hairdresser list — required for the Team tab to populate staff data.
        // On desktop this may already be in Redux from the parent page, but on mobile
        // (or direct URL navigation) it won't be, so we always fetch it here.
        dispatch(newServicesAction.listHairDresserData({}))
          .then((res) => {
            console.log("EditService listHairDresserData loaded:", res);
          })
          .catch((error) => {
            console.error("Error loading hairdresser list:", error);
          });
      setTimeout(()=>{
        viewService(id)
      },500)
      // Load automatic forms from API
      formService.listForms({ status: 'active', formType: 'automatic' })
        .then((response) => {
          const data = response.data?.responseData || {};
          const forms = data.result || [];
          setAvailableAutoForms(forms);
          // Identify forms that auto-attach to this service via FormSettings
          const autoForms = forms.filter(f => {
            const settings = f.settings || {};
            if (settings.formRequiredFor === 'every_service') return true;
            if (settings.formRequiredFor === 'specific_services') {
              return (settings.specificServices || []).includes(id);
            }
            return false;
          }).map(f => ({
            formId: f._id || f.id,
            formName: f.name,
            isRequired: true,
            isAutoAttached: true
          }));
          setAutoAttachedForms(autoForms);
        })
        .catch(() => setAvailableAutoForms([]));
      // Load all services for booking rules pickers
      dispatch(newServicesAction.listServicesData({}))
        .then(res => {
            const services = [];
            (res?.listServices || []).forEach(cat => {
                (cat.serviceList || []).forEach(svc => {
                    services.push({ id: svc.commonServiceId || svc._id, name: svc.serviceName });
                });
            });
            setAllServices(services.filter(s => s.id !== id));
        })
        .catch(() => {});
    },[])

    useEffect(() => {
      if (serviceResponse && listHairdresser?.length > 0) {
          console.log("Updating with hairdressers:", listHairdresser);
          let selectedCategoryOptions = categoryOptions?.find((item) =>
              item?.value == serviceResponse?.categoryID
          );

          // Get the default diary color from the service response
          // If the service doesn't have a diaryColour property, use the first hairdresser's color
          // or fall back to '#c8eeee' if no colors are available
          const defaultColor = serviceResponse?.diaryColour || '#c8eeee';
          console.log("Loading service with default color:", defaultColor);
          
          // Log all hairdresser colors from the API response
          console.log("API Response hairdresser colors:");
          if (serviceResponse?.hairdresserService) {
              serviceResponse.hairdresserService.forEach(hs => {
                  console.log(`${hs.name}: ${hs.diaryColour}`);
              });
          }

          // Check if any hairdresser service has isFeaturedForSalon set to true
          const isFeaturedForSalon = serviceResponse?.hairdresserService?.some(item => item.isFeaturedForSalon) || false;
          
          setServiceData(prev => ({
              ...prev,
              category: selectedCategoryOptions || null,
              serviceName: serviceResponse?.serviceName || '',
              description: serviceResponse?.serviceDescription || '',
              // Use the service's diary color as the default
              defaultDiaryColour: defaultColor,
              // Load service images array from response
              serviceImages: serviceResponse?.serviceImages || [],
              // Load salon-level featured status
              isFeaturedForSalon: isFeaturedForSalon,
              serviceEditBy: {
                  name: serviceResponse?.serviceEditBy?.name,
                  userImage: {
                      circleImage: serviceResponse?.serviceEditBy?.userImage?.circleImage,
                      rectangleImage: serviceResponse?.serviceEditBy?.userImage?.rectangleImage
                  }
              },
              staffSettings: serviceResponse?.hairdresserService?.map((item) => {
                  const hairdresser = listHairdresser?.find(h => h._id === item.hairdresserId);
                  
                  // Always use the hairdresser's specific color from the API if available
                  // This ensures each hairdresser gets their own color from the API
                  const staffColor = item.diaryColour || defaultColor;
                  
                  // Consider a color overridden if it's different from the default
                  const isOverridden = item.diaryColour && item.diaryColour !== defaultColor;
                  
                  console.log(`Staff ${item.name}: color=${staffColor}, isOverridden=${isOverridden}`);
                  
                  return {
                      hairdresserId: item.hairdresserId,
                      name: hairdresser?.name || '',
                      servicePrice: parseFloat(item.servicePrice) || 0,
                      serviceTime: parseFloat(item.serviceTime) || 0,
                      isDeactivated: !item.isDeactivated || false,
                      depositPrice: parseFloat(item.depositPrice) || 0,
                      onlineBooking: item.onlineBooking || false,
                      processingTime: parseFloat(item.processingTime) || 0,
                      setupTime: parseFloat(item.setupTime) || 0,
                      cleanupTime: parseFloat(item.cleanupTime) || 0,
                      requiresFinishing: item.requiresFinishing || false,
                      finishingServiceIds: item.finishingServiceIds || [],
                      finishingSameStylist: item.finishingSameStylist !== false,
                      requiresConsultation: item.requiresConsultation || false,
                      consultationServiceId: item.consultationServiceId || null,
                      consultationSameStylist: item.consultationSameStylist !== false,
                      finishingMessage: item.finishingMessage || '',
                      consultationMessage: item.consultationMessage || '',
                      diaryColour: staffColor,
                      isColourOverridden: isOverridden,
                      staffServiceImages: item.staffServiceImages || [],
                      isFeaturedForStaff: item.isFeaturedForStaff || false,
                      linkedForms: (item.linkedForms || []).map(lf => ({
                        formId: lf.formId,
                        formName: lf.formName,
                        isRequired: lf.isRequired !== false
                      }))
                  }
              })
          }));
      }
  }, [listHairdresser, serviceResponse]);


    // --- Per-Staff Linked Forms Helpers ---
    const handleAddStaffForm = (staffIndex, form) => {
      const fId = form._id || form.id;
      setServiceData(prev => {
        const newStaffSettings = prev.staffSettings.map((staff, i) => {
          if (i !== staffIndex) return { ...staff };
          const current = staff.linkedForms || [];
          if (current.find(f => f.formId === fId)) return { ...staff };
          return {
            ...staff,
            linkedForms: [...current, { formId: fId, formName: form.name, isRequired: true }]
          };
        });
        return { ...prev, staffSettings: newStaffSettings };
      });
      setFormSelectorOpenIndex(null);
    };

    const handleRemoveStaffForm = (staffIndex, formId) => {
      setServiceData(prev => {
        const newStaffSettings = prev.staffSettings.map((staff, i) => {
          if (i !== staffIndex) return { ...staff };
          return {
            ...staff,
            linkedForms: (staff.linkedForms || []).filter(f => f.formId !== formId)
          };
        });
        return { ...prev, staffSettings: newStaffSettings };
      });
    };

    const renderServiceDetails = () => {
      // Compute diary colour display
      const uniqueColors = new Set();
      serviceData.staffSettings.forEach(s => { if (s.diaryColour) uniqueColors.add(s.diaryColour); });
      const hasMultipleColors = uniqueColors.size > 1;
      let displayColor = serviceData.defaultDiaryColour;
      if (uniqueColors.size === 1) displayColor = Array.from(uniqueColors)[0];
      else if (hasMultipleColors) displayColor = `linear-gradient(to right, ${Array.from(uniqueColors).join(', ')})`;

      return (
        <>
          {/* Service Details */}
          <div className="sep-section">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
              <p className="sep-section-label">Service Details</p>
              {serviceData?.serviceEditBy?.name && (
                <div style={{ position: 'relative' }} onMouseEnter={showTooltipFn} onMouseLeave={hideTooltipFn}>
                  <img
                    src={serviceData?.serviceEditBy?.userImage?.circleImage || require('../../../assets/images/Pixie.png')}
                    alt=""
                    style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', cursor: 'pointer' }}
                  />
                  {showTooltip && (
                    <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: '6px', padding: '8px 14px', backgroundColor: '#1a1a1a', color: 'white', borderRadius: '8px', fontSize: '12px', whiteSpace: 'nowrap', zIndex: 10 }}>
                      Service added by {serviceData?.serviceEditBy?.name}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="sep-field">
              <label className="sep-field-label">Service Name</label>
              <input className={`sep-input ${errors.serviceName ? 'sep-input--error' : ''}`} type="text" name="serviceName" placeholder="e.g. Haircut" value={serviceData.serviceName} onChange={handleChange} />
              {errors.serviceName && <span className="sep-error">{errors.serviceName}</span>}
            </div>

            <div className="sep-field">
              <label className="sep-field-label">Category</label>
              <InlinePickerSelect
                options={categoryOptions}
                value={serviceData.category}
                onChange={handleCategoryChange}
                onCreateNew={async (name) => {
                  try {
                    await newServices.createCategory({ categoryName: name });
                    await dispatch(newServicesAction.listCategoryData({}));
                    toast.success('Category created');
                  } catch { toast.error('Failed to create category'); throw new Error(); }
                }}
                placeholder="Choose a Category"
                createLabel="Create new category"
                searchPlaceholder="Search categories..."
                error={errors.category}
              />
            </div>

            <div className="sep-field">
              <label className="sep-field-label">Service Description</label>
              <textarea className="sep-input sep-textarea" name="description" placeholder="e.g. Transform your look with a professional haircut tailored to your style preferences..." value={serviceData.description} onChange={handleChange} />
            </div>
          </div>

          {/* Service Images */}
          {isSalonManager && (
            <div className="sep-section">
              <p className="sep-section-label">Images</p>
              <div className="sep-images-grid">
                {(serviceData.serviceImages || []).map((imageUrl, index) => (
                  <div key={index} className="sep-image-item">
                    <img src={imageUrl} alt={`Service ${index + 1}`} />
                    <button type="button" className="sep-image-delete" onClick={() => handleDeleteServiceImage(imageUrl)} disabled={uploadingServiceImage}>×</button>
                  </div>
                ))}
                <div className="sep-image-upload" style={{ position: 'relative' }}>
                  {uploadingServiceImage ? <span>Uploading...</span> : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                      <span>Add</span>
                    </>
                  )}
                  <input type="file" accept="image/*" onChange={handleServiceImageUpload} disabled={uploadingServiceImage} style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }} />
                </div>
              </div>
              <p style={{ fontSize: '12px', color: '#8e8e93', marginTop: '8px' }}>Max 5MB per image. JPG, PNG, GIF supported.</p>
            </div>
          )}

          {/* Online Booking */}
          {isSalonManager && (
            <div className="sep-section">
              <p className="sep-section-label">Online Booking</p>
              <div className="sep-toggle-row" style={{ borderBottom: 'none' }}>
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">Featured for Salon</div>
                  <div className="sep-toggle-desc">
                    {serviceData.isFeaturedForSalon ? 'Shown in featured section on booking page' : 'Not featured on booking page'}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleToggleFeaturedForSalon}
                  style={{
                    width: '40px', height: '40px', borderRadius: '10px',
                    border: serviceData.isFeaturedForSalon ? '2px solid #ffc107' : '1px solid #e5e5e5',
                    background: serviceData.isFeaturedForSalon ? '#fff8e1' : '#fff',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '22px', transition: 'all 0.2s cubic-bezier(0.32, 0.72, 0, 1)',
                    flexShrink: 0,
                  }}
                >
                  <span style={{ color: serviceData.isFeaturedForSalon ? '#ffc107' : '#ccc', transition: 'color 0.2s ease' }}>★</span>
                </button>
              </div>
            </div>
          )}

          {/* Diary Colour */}
          {isSalonManager && (
            <div className="sep-section">
              <p className="sep-section-label">Diary Colour</p>
              <ColourPicker
                value={serviceData.defaultDiaryColour}
                onChange={(hex) => handleDefaultDiaryColourChange(hex)}
                onReset={handleResetToSystem}
                resetLabel="Reset to Default"
              />
              {hasMultipleColors && (
                <p style={{ fontSize: '12px', color: '#8e8e93', marginTop: '8px' }}>Some staff have custom colours. This sets the default for all.</p>
              )}
            </div>
          )}

          {/* Discount codes that cover this service (Marketing › Discounts) */}
          <ServiceCodes serviceId={id} serviceName={serviceData.serviceName} categoryId={serviceData.category && (serviceData.category.value || serviceData.category)} />
        </>
      );
    };

    const currencySymbol = userInfo?.userInfo?.hairdresser?.currencySymbol || '£';

    const enabledCount = serviceData.staffSettings.filter(s => s.isDeactivated).length;
    const totalCount = serviceData.staffSettings.length;

    const renderStaffSettings = () => (
      <div style={{ marginTop: '16px' }}>
        <div className="sep-staff-summary">{enabledCount} of {totalCount} enabled</div>
        {serviceData.staffSettings.map((staff, index) => {
          const isEnabled = staff.isDeactivated;
          const price = parseFloat(staff.servicePrice) || 0;
          const duration = parseFloat(staff.serviceTime) || 0;
          const deposit = parseFloat(staff.depositPrice) || 0;
          const manualCount = (staff.linkedForms || []).length;
          const autoCount = autoAttachedForms.filter(af => !(staff.linkedForms || []).find(lf => lf.formId === af.formId)).length;
          const totalForms = manualCount + autoCount;
          const imageCount = (staff.staffServiceImages || []).length;

          return (
            <div
              key={staff.hairdresserId}
              className={`sep-staff-card ${!isEnabled ? 'sep-staff-card--disabled' : ''}`}
              onClick={() => setSelectedStaffIndex(index)}
            >
              <span className="sep-staff-dot" style={{ background: staff.diaryColour || serviceData.defaultDiaryColour }} />
              <div className="sep-staff-info">
                <p className="sep-staff-name">{staff.name || 'Staff'}</p>
                <div className="sep-staff-meta">
                  {deposit > 0 && <><span>{currencySymbol}{deposit.toFixed(2)} deposit</span><span className="sep-staff-meta-dot" /></>}
                  {totalForms > 0 && <><span>{totalForms} {totalForms === 1 ? 'form' : 'forms'}</span><span className="sep-staff-meta-dot" /></>}
                  {imageCount > 0 && <><span>{imageCount} {imageCount === 1 ? 'image' : 'images'}</span><span className="sep-staff-meta-dot" /></>}
                  {staff.isFeaturedForStaff && <span>★ Featured</span>}
                </div>
              </div>
              <div className="sep-staff-pricing">
                {duration > 0 && <span className="sep-staff-duration">{duration}m</span>}
                <span className="sep-staff-price">{price > 0 ? `${currencySymbol}${price.toFixed(2)}` : '-'}</span>
              </div>
              <div className="sep-staff-toggle" onClick={(e) => e.stopPropagation()}>
                <button
                  type="button"
                  className={`sep-toggle ${isEnabled ? 'sep-toggle--on' : ''}`}
                  onClick={() => handleStaffSettingChange(index, 'isDeactivated', !staff.isDeactivated)}
                >
                  <span className="sep-toggle-knob" />
                </button>
              </div>
            </div>
          );
        })}
        {serviceData.staffSettings.length === 0 && (
          <div style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ fontSize: '14px', color: '#8e8e93' }}>No staff members found</p>
          </div>
        )}
      </div>
    );

    const renderStaffDetailPanel = () => {
      if (selectedStaffIndex === null || !serviceData.staffSettings[selectedStaffIndex]) return null;
      const staff = serviceData.staffSettings[selectedStaffIndex];
      const index = selectedStaffIndex;
      const closePanel = () => { setSelectedStaffIndex(null); setFormSelectorOpenIndex(null); };

      return (
        <div className="sep-staff-detail">
          {/* Back to team */}
          <button className="sep-back-to-team" onClick={closePanel}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            <span>Back to Team</span>
          </button>

          <div className="sep-staff-detail-header">
            <span className="sep-staff-dot" style={{ background: staff.diaryColour || serviceData.defaultDiaryColour, width: '12px', height: '12px' }} />
            <div>
              <h3 className="sep-staff-detail-name">{staff.name}</h3>
              <span className="sep-staff-detail-sub">Service settings for this team member</span>
            </div>
          </div>

            {/* Availability */}
            <div className="sep-section">
              <p className="sep-section-label">Availability</p>
              <div className="sep-toggle-row">
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">Service Enabled</div>
                  <div className="sep-toggle-desc">Allow this staff member to perform this service</div>
                </div>
                <button type="button" className={`sep-toggle ${staff.isDeactivated ? 'sep-toggle--on' : ''}`}
                  onClick={() => handleStaffSettingChange(index, 'isDeactivated', !staff.isDeactivated)}>
                  <span className="sep-toggle-knob" />
                </button>
              </div>
              <div className="sep-toggle-row">
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">Online Bookings</div>
                  <div className="sep-toggle-desc">Clients can book this service online</div>
                </div>
                <button type="button" className={`sep-toggle ${staff.onlineBooking ? 'sep-toggle--on' : ''}`}
                  onClick={() => handleStaffSettingChange(index, 'onlineBooking', !staff.onlineBooking)}>
                  <span className="sep-toggle-knob" />
                </button>
              </div>
              <div className="sep-toggle-row" style={{ borderBottom: 'none' }}>
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">Featured for Staff Page</div>
                  <div className="sep-toggle-desc">
                    {staff.isFeaturedForStaff ? 'Shown in featured section on booking page' : 'Not featured on booking page'}
                  </div>
                </div>
                <button type="button" onClick={() => handleToggleFeaturedForStaff(index, staff.hairdresserId)}
                  className={`sep-star-btn ${staff.isFeaturedForStaff ? 'sep-star-btn--active' : ''}`}>
                  <span>★</span>
                </button>
              </div>
            </div>

            {/* Pricing */}
            <div className="sep-section">
              <p className="sep-section-label">Pricing</p>
              <div className="sep-field-row">
                <div className="sep-field">
                  <label className="sep-field-label">Price ({currencySymbol})</label>
                  <input className="sep-input" type="number" value={staff.servicePrice}
                    onChange={(e) => handleStaffSettingChange(index, 'servicePrice', e.target.value)} placeholder="0.00" />
                </div>
                <div className="sep-field">
                  <label className="sep-field-label">Deposit ({currencySymbol})</label>
                  <input className={`sep-input ${errors[`depositPrice_${index}`] ? 'sep-input--error' : ''}`}
                    type="number" value={staff.depositPrice}
                    onChange={(e) => handleStaffSettingChange(index, 'depositPrice', e.target.value)} placeholder="0.00" />
                  {errors[`depositPrice_${index}`] && <span className="sep-error">{errors[`depositPrice_${index}`]}</span>}
                </div>
              </div>
            </div>

            {/* Timing */}
            <div className="sep-section">
              <p className="sep-section-label">Timing</p>
              <div className="sep-field-row">
                <div className="sep-field">
                  <label className="sep-field-label">Duration (min)</label>
                  <input className={`sep-input ${errors[`serviceTime_${index}`] ? 'sep-input--error' : ''}`}
                    type="number" value={staff.serviceTime}
                    onChange={(e) => handleStaffSettingChange(index, 'serviceTime', e.target.value)} placeholder="0" />
                  {errors[`serviceTime_${index}`] && <span className="sep-error">{errors[`serviceTime_${index}`]}</span>}
                </div>
                <div className="sep-field">
                  <label className="sep-field-label">Processing (min)</label>
                  <input className={`sep-input ${errors[`processingTime_${index}`] ? 'sep-input--error' : ''}`}
                    type="number" value={staff.processingTime}
                    onChange={(e) => handleStaffSettingChange(index, 'processingTime', e.target.value)} placeholder="0" />
                  <span className="sep-field-hint">Time where the client is waiting (e.g. colour developing) and you're free to take other bookings</span>
                  {errors[`processingTime_${index}`] && <span className="sep-error">{errors[`processingTime_${index}`]}</span>}
                </div>
              </div>
              <div className="sep-field-row">
                <div className="sep-field">
                  <label className="sep-field-label">Setup time (min)</label>
                  <input className="sep-input" type="number" value={staff.setupTime || ''}
                    onChange={(e) => handleStaffSettingChange(index, 'setupTime', e.target.value)} placeholder="0" />
                  <span className="sep-field-hint">Buffer before appointment</span>
                </div>
                <div className="sep-field">
                  <label className="sep-field-label">Cleanup time (min)</label>
                  <input className="sep-input" type="number" value={staff.cleanupTime || ''}
                    onChange={(e) => handleStaffSettingChange(index, 'cleanupTime', e.target.value)} placeholder="0" />
                  <span className="sep-field-hint">Buffer after appointment</span>
                </div>
              </div>
            </div>

            {/* Booking Rules */}
            <div className="sep-section">
              <p className="sep-section-label">Booking Rules</p>

              {/* Requires finishing service */}
              <div className="sep-toggle-row">
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">Requires finishing service</div>
                  <div className="sep-toggle-desc">Client must also book a finishing service</div>
                </div>
                <button type="button" className={`sep-toggle ${staff.requiresFinishing ? 'sep-toggle--on' : ''}`}
                  onClick={() => {
                    handleStaffSettingChange(index, 'requiresFinishing', !staff.requiresFinishing);
                    if (staff.requiresFinishing) { handleStaffSettingChange(index, 'finishingServiceIds', []); setFinishingSearch(''); }
                  }}>
                  <span className="sep-toggle-knob" />
                </button>
              </div>
              <div className={`sep-expand ${staff.requiresFinishing ? 'sep-expand--open' : ''}`}>
                {/* "Same stylist only" toggle removed for now: bookings and
                    checkout currently only support the same-stylist-only
                    behaviour, so the toggle was misleading. The
                    `finishingSameStylist` value still defaults to true via
                    `!== false`, so existing data flows untouched. Re-add the
                    toggle here when multi-stylist finishing is supported. */}
                {(staff.finishingServiceIds || []).length > 0 && (
                  <div className="sep-chips">
                    {(staff.finishingServiceIds || []).map(svcId => {
                      const svc = allServices.find(s => s.id === svcId);
                      return svc ? (
                        <span key={svcId} className="sep-chip">
                          {svc.name}
                          <button type="button" className="sep-chip-remove"
                            onClick={() => handleStaffSettingChange(index, 'finishingServiceIds', (staff.finishingServiceIds || []).filter(sid => sid !== svcId))}>
                            ×
                          </button>
                        </span>
                      ) : null;
                    })}
                  </div>
                )}
                <div className="sep-service-picker">
                  <input type="text" className="sep-service-search" placeholder="Search finishing services..."
                    value={finishingSearch} onChange={(e) => setFinishingSearch(e.target.value)} />
                  <div className="sep-service-list">
                    {allServices
                      .filter(s => !finishingSearch || s.name.toLowerCase().includes(finishingSearch.toLowerCase()))
                      .map(svc => {
                        const isSelected = (staff.finishingServiceIds || []).includes(svc.id);
                        return (
                          <button key={svc.id} type="button" className="sep-service-item"
                            onClick={() => {
                              const current = staff.finishingServiceIds || [];
                              handleStaffSettingChange(index, 'finishingServiceIds',
                                isSelected ? current.filter(sid => sid !== svc.id) : [...current, svc.id]);
                            }}>
                            <span className={`sep-service-check ${isSelected ? 'sep-service-check--active' : ''}`}>
                              {isSelected && (
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              )}
                            </span>
                            {svc.name}
                          </button>
                        );
                      })}
                    {allServices.filter(s => !finishingSearch || s.name.toLowerCase().includes(finishingSearch.toLowerCase())).length === 0 && (
                      <div className="sep-service-empty">No services found</div>
                    )}
                  </div>
                </div>
                {/* Client-facing message */}
                <div className="sep-field" style={{ marginTop: '12px' }}>
                  <label className="sep-field-label">Message for clients</label>
                  <textarea className="sep-input sep-textarea" rows={2}
                    value={staff.finishingMessage || ''}
                    onChange={(e) => handleStaffSettingChange(index, 'finishingMessage', e.target.value)}
                    placeholder="e.g. This service requires a cut or blowdry to complete your look. Please add one to your booking." />
                  <span className="sep-field-hint">Shown on the booking page when this rule applies</span>
                </div>
              </div>

              {/* First visit consultation */}
              <div className="sep-toggle-row">
                <div className="sep-toggle-info">
                  <div className="sep-toggle-title">First visit consultation</div>
                  <div className="sep-toggle-desc">New clients must complete a consultation</div>
                </div>
                <button type="button" className={`sep-toggle ${staff.requiresConsultation ? 'sep-toggle--on' : ''}`}
                  onClick={() => {
                    handleStaffSettingChange(index, 'requiresConsultation', !staff.requiresConsultation);
                    if (staff.requiresConsultation) { handleStaffSettingChange(index, 'consultationServiceId', null); setConsultationSearch(''); }
                  }}>
                  <span className="sep-toggle-knob" />
                </button>
              </div>
              <div className={`sep-expand ${staff.requiresConsultation ? 'sep-expand--open' : ''}`}>
                {/* Same stylist toggle - FIRST */}
                <div className="sep-toggle-row">
                  <div className="sep-toggle-info">
                    <div className="sep-toggle-title">Same stylist only</div>
                    <div className="sep-toggle-desc">Consultation must be with the same person</div>
                  </div>
                  <button type="button" className={`sep-toggle ${staff.consultationSameStylist !== false ? 'sep-toggle--on' : ''}`}
                    onClick={() => handleStaffSettingChange(index, 'consultationSameStylist', staff.consultationSameStylist === false)}>
                    <span className="sep-toggle-knob" />
                  </button>
                </div>
                {/* Consultation service picker */}
                <div className="sep-service-picker">
                  <input type="text" className="sep-service-search" placeholder="Search consultation services..."
                    value={consultationSearch} onChange={(e) => setConsultationSearch(e.target.value)} />
                  <div className="sep-service-list">
                    {allServices
                      .filter(s => !consultationSearch || s.name.toLowerCase().includes(consultationSearch.toLowerCase()))
                      .map(svc => {
                        const isSelected = staff.consultationServiceId === svc.id;
                        return (
                          <button key={svc.id} type="button" className="sep-service-item"
                            onClick={() => handleStaffSettingChange(index, 'consultationServiceId', isSelected ? null : svc.id)}>
                            <span className={`sep-service-check ${isSelected ? 'sep-service-check--active' : ''}`}>
                              {isSelected && (
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              )}
                            </span>
                            {svc.name}
                          </button>
                        );
                      })}
                    {allServices.filter(s => !consultationSearch || s.name.toLowerCase().includes(consultationSearch.toLowerCase())).length === 0 && (
                      <div className="sep-service-empty">No services found</div>
                    )}
                  </div>
                </div>
                {/* Client-facing message */}
                <div className="sep-field" style={{ marginTop: '12px' }}>
                  <label className="sep-field-label">Message for clients</label>
                  <textarea className="sep-input sep-textarea" rows={2}
                    value={staff.consultationMessage || ''}
                    onChange={(e) => handleStaffSettingChange(index, 'consultationMessage', e.target.value)}
                    placeholder="e.g. A consultation is required before your first visit so we can understand your needs and ensure the best results." />
                  <span className="sep-field-hint">Shown on the booking page for new clients</span>
                </div>
              </div>
            </div>

            {/* Appearance */}
            <div className="sep-section">
              <p className="sep-section-label">Appearance</p>
              <ColourPicker
                value={staff.diaryColour || serviceData.defaultDiaryColour}
                onChange={(hex) => { handleStaffSettingChange(index, 'diaryColour', hex); handleStaffSettingChange(index, 'isColourOverridden', true); }}
                onReset={() => { handleStaffSettingChange(index, 'diaryColour', serviceData.defaultDiaryColour); handleStaffSettingChange(index, 'isColourOverridden', false); }}
                resetLabel="Reset to Service Default"
              />
            </div>

            {/* Linked Forms */}
            <div className="sep-section">
              <p className="sep-section-label">Linked Forms</p>
              {autoAttachedForms
                .filter(af => !(staff.linkedForms || []).find(lf => lf.formId === af.formId))
                .map((af) => (
                <div key={`auto-${af.formId}`} className="sep-toggle-row">
                  <div className="sep-toggle-info">
                    <div className="sep-toggle-title">{af.formName}</div>
                  </div>
                  <span className="sep-badge sep-badge--auto">Auto</span>
                </div>
              ))}
              {(staff.linkedForms || []).map((lf) => (
                <div key={lf.formId} className="sep-toggle-row">
                  <div className="sep-toggle-info">
                    <div className="sep-toggle-title">{lf.formName}</div>
                  </div>
                  <button type="button" onClick={() => handleRemoveStaffForm(index, lf.formId)}
                    className="sep-back-btn" style={{ width: '28px', height: '28px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </button>
                </div>
              ))}
              {formSelectorOpenIndex === index ? (
                <div className="sdp-staff-list" style={{ marginTop: '8px' }}>
                  {availableAutoForms
                    .filter(f => !(staff.linkedForms || []).find(lf => lf.formId === (f._id || f.id)))
                    .length > 0 ? (
                    availableAutoForms
                      .filter(f => !(staff.linkedForms || []).find(lf => lf.formId === (f._id || f.id)))
                      .map((form) => (
                        <div key={form._id || form.id} className="sdp-staff-row" onClick={() => handleAddStaffForm(index, form)} style={{ cursor: 'pointer' }}>
                          <span className="sdp-staff-name">{form.name}</span>
                        </div>
                      ))
                  ) : (
                    <div className="sdp-staff-row"><span style={{ color: '#8e8e93', fontSize: '13px' }}>No forms available</span></div>
                  )}
                  <div className="sdp-staff-row" onClick={() => setFormSelectorOpenIndex(null)} style={{ cursor: 'pointer', justifyContent: 'center' }}>
                    <span style={{ color: '#8e8e93', fontSize: '13px' }}>Close</span>
                  </div>
                </div>
              ) : (
                <div className="sep-image-upload" onClick={() => setFormSelectorOpenIndex(index)} style={{ aspectRatio: 'auto', padding: '10px', marginTop: '8px' }}>
                  <span>+ Add Form</span>
                </div>
              )}
            </div>

            {/* Staff Images */}
            <div className="sep-section">
              <p className="sep-section-label">
                Portfolio Images
                {(staff.staffServiceImages || []).length > 0 && (
                  <span style={{ fontWeight: '400', color: '#8e8e93', marginLeft: '6px' }}>({staff.staffServiceImages.length})</span>
                )}
              </p>
              <div className="sep-images-grid">
                {(staff.staffServiceImages || []).map((imageUrl, imgIndex) => (
                  <div key={imgIndex} className="sep-image-item">
                    <img src={imageUrl} alt={`${staff.name} service ${imgIndex + 1}`} />
                    <button type="button" className="sep-image-delete"
                      onClick={() => handleDeleteStaffServiceImage(index, staff.hairdresserId, imageUrl)}
                      disabled={uploadingStaffImage === index}>×</button>
                  </div>
                ))}
                <div className="sep-image-upload" style={{ position: 'relative' }}>
                  {uploadingStaffImage === index ? (
                    <span>Uploading...</span>
                  ) : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                      <span>Add</span>
                    </>
                  )}
                  <input type="file" accept="image/*"
                    onChange={(e) => handleStaffServiceImageUpload(e, index, staff.hairdresserId)}
                    disabled={uploadingStaffImage === index}
                    style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }} />
                </div>
              </div>
              <p style={{ fontSize: '12px', color: '#8e8e93', marginTop: '8px' }}>Max 5MB per image. JPG, PNG, GIF supported.</p>
            </div>

        </div>
      );
    };

  
    return (
      <>
      <div className="h_n _new__service catalogue-no-header">
      <div className="body_container cm_bg_white">
        <div className="catalogue-page-wrapper">
          <CatalogueTopNav>
            <button
              type="button"
              className="catalogue-add-btn"
              onClick={handleSave}
            >
              Save
            </button>
          </CatalogueTopNav>
          <div className="catalogue-content-container">
            <div className="catalogue-content-wrapper">
              {/* Tab Navigation */}
              <div className="sep-tabs">
                {[{ id: 'detail', label: 'Detail' }, { id: 'team', label: 'Team' }].map(tab => (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                    className={`sep-tab ${activeTab === tab.id ? 'sep-tab--active' : ''}`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Tab Content */}
              <div style={{ paddingTop: '24px' }}>
                {activeTab === 'detail' && renderServiceDetails()}
                {activeTab === 'team' && selectedStaffIndex === null && renderStaffSettings()}
                {activeTab === 'team' && selectedStaffIndex !== null && renderStaffDetailPanel()}
              </div>
              <div style={{ height: '24px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
    )
}

export default EditService
// function mapStateToProps(state) {
//   return {
//     ...state,
//   };
// }

// export default connect(mapStateToProps)(EditService);
